import { useState, useEffect } from 'react';
import { FFFStorage, Compare } from '@fff-web/fff-utilities';
import get from 'lodash/get';
import { getInviteContext } from '../services/invite';

const inviteContextKey = 'invite-context';
const cacheDurationInMs = 20 * 60 * 1000; //20 minutes

const useInviteContext = () => {
  const [inviteInfo, setInviteInfo] = useState(FFFStorage.getFromStorage({ key: inviteContextKey }));

  useEffect(() => {
    const inviteInfoCache = FFFStorage.getFromStorage({ key: inviteContextKey });
    if (inviteInfoCache) {
      if (!Compare.isEqualObject(inviteInfo, inviteInfoCache)) {
        setInviteInfo(inviteInfoCache);
      }
    } else {
      getInviteContext().then((invite) => {
        const inviteData = get(invite, 'data.items[0]', {});
        setInviteInfo(inviteData);
        FFFStorage.setToStorage({ key: inviteContextKey, value: invite, durationInMs: cacheDurationInMs });
      });
    }
  }, []);

  return { inviteInfo };
};

export default useInviteContext;
